import React from 'react';
import {
  Box,
  Heading,
  FormControl,
  Flex,
  VStack,
} from '@chakra-ui/react';
import Label from '../../components/Intake/Label';
import InputField from './form/InputField';
import {
  required,
  email,
  compose,
  phone,
} from './form/validators';

const BusinessContactView = (): JSX.Element => {
  return (
    <fieldset>
      <legend>
        <Heading fontSize="2xl" mb={6}>Business Contact</Heading>
      </legend>
      <VStack spacing={5} width="100%">
        <FormControl>
          <Label>Contact Name</Label>
          <Flex gap={5} flexWrap="wrap">
            <Box flexGrow={1}>
              <InputField
                name="contact.firstName"
                maxLength={128}
                placeholder="John"
                validate={required('Required')}
              />
            </Box>
            <Box flexGrow={1}>
              <InputField
                name="contact.lastName"
                maxLength={128}
                placeholder="Smith"
              />
            </Box>
          </Flex>
        </FormControl>
        <InputField
          name="contact.email"
          label="Contact Email"
          placeholder="businesscontact@email.com"
          maxLength={70}
          validate={compose(required('Required'), email('Please enter a valid email address.'))}
        />
        <InputField
          name="contact.phone"
          label="Contact Phone Number"
          placeholder="604-555-1212"
          validate={phone()}
        />
      </VStack>
    </fieldset>
  );
};

export default BusinessContactView;
